module.exports = __webpack_public_path__ + "img/placeholder.678046a0.png";